import { useId } from "react";

import { cn } from "@/lib/utils";

export function CheckedCheckboxIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-5", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill={`url(#${id})`} height="20" rx="3" width="19.231" x="0.769" />
      <path
        clipRule="evenodd"
        d="M8.328 12.605l6.17-6.314a.954.954 0 011.372 0 1.008 1.008 0 010 1.403l-6.857 7.015a.954.954 0 01-1.37 0l-2.744-2.806a1.008 1.008 0 010-1.403.954.954 0 011.372 0l2.057 2.105z"
        fill="#fff"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="5.577"
          x2="-4.415"
          y1="5"
          y2="14.608"
        >
          <stop stopColor="#bd2885" />
          <stop offset="1" stopColor="#90278e" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function UncheckedCheckboxIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white/20", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        fill="none"
        height="19"
        rx="2.5"
        stroke="currentColor"
        width="19"
        x="0.5"
        y="0.5"
      />
    </svg>
  );
}
